<div class="preview-dialog">
    <div *ngIf="!initialized" class="preview-loading-wrap">
        <sync-spinner></sync-spinner>
     </div>
    <ng-container>
        <img 
        *ngIf="transferView?.single?.renderFile?.dl_ready && !item.previewonly && initialized" 
        [src]="imageURL"
        class="preview-wrap-img img-responsive"/>
    </ng-container>
        
</div>